// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30c4O","top":"styles_top__3V_p9","left":"styles_left__18igs","description":"styles_description__7nNHK"};